import axios from "axios";
import { setAuth } from "components/feature/auth/actions";

export const SET_APP = "app:SET_APP";
export const SET_SCROLLED_DOWN = "app:SET_SCROLLED_DOWN";
export const SET_GEO_LOCATION = "app:SET_GEO_LOCATION";

export const setApp = (app) => {
  return {
    type: SET_APP,
    payload: app,
  };
};

export const loadAppStuff = (profile) => async (dispatch) => {
  // check if dismissed betbar help tooltip
  dispatch(
    setApp({
      hasReadBetbarHelp:
        localStorage.getItem("fiver_has_read_betbar_help") === "true",
      showAffiliateBanners:
        process.env.REACT_APP_SHOW_AFFILIATE_BANNERS === "true",
      affiliateBannerUrl: process.env.REACT_APP_AFFILIATE_BANNER_URL,
      isDevEnvironment: process.env.NODE_ENV === "development",
    })
  );

  let mobileNumber,
    mobileNumberVerified,
    identityPassed,
    nonUkUser,
    username,
    image,
    dataSharePermissions,
    walletBalance,
    walletPromoBalance,
    tenantDetails;

  try {
    if (!profile) {
      const profileRes = await axios.get("/me");
      profile = profileRes?.data?.data;

      mobileNumber = profile?.mobileNumber;
      mobileNumberVerified = !!profile.mobileNumberVerified;
      identityPassed = profile.identityPassed;
      nonUkUser = profile.nonUkUser;
      username = profile.username;
      image = profile.image;
      dataSharePermissions = profile.dataSharePermissions;
    }
  } catch (error) {
    // continue
  }

  // get wallet
  try {
    const walletRes = await axios.get(`/wallet`);

    // if there is a walletRes assume the user is logged in
    dispatch(
      setAuth({
        isLoggedIn: true,
      })
    );

    walletBalance = walletRes?.data?.data?.balance;
    walletPromoBalance = walletRes?.data?.data?.promoBalance;
  } catch (error) {
    // continue
  }

  // get tenant details
  try {
    const tenantDetailsRes = await axios.get("/tenant");
    tenantDetails = tenantDetailsRes?.data?.data;
  } catch (error) {
    // continue
  }

  // check if dismissed betbar help tooltip
  const hasReadBetbarHelp = localStorage.getItem("fiver_has_read_betbar_help");

  const appStuff = {
    tenantDetails,
    mobileNumber,
    showAffiliateBanners:
      process.env.REACT_APP_SHOW_AFFILIATE_BANNERS === "true",
    affiliateBannerUrl: process.env.REACT_APP_AFFILIATE_BANNER_URL,
    isDevEnvironment: process.env.NODE_ENV === "development",
    isMobileNumberVerified: mobileNumberVerified,
    isIdentityPassed: identityPassed,
    isNonUkUser: nonUkUser,
    profile,
    loggedInUserName: username,
    loggedInUserImage: image,
    walletBalance,
    walletPromoBalance,
    hasReadBetbarHelp: hasReadBetbarHelp ? true : false,
  };

  dispatch(setApp(appStuff));
};

export function setScrolledDown(value) {
  return {
    type: SET_SCROLLED_DOWN,
    payload: value,
  };
}

export function setGeoLocation(data) {
  return {
    type: SET_GEO_LOCATION,
    payload: data,
  };
}
